













import Vue from "vue";

export default Vue.extend({
  name: "FilterHead",
  props: {
    titleHighlighted: {
      type: String,
      required: true,
    },
    titleEnd: {
      type: String,
      required: true,
    },
    perfectMatches: {
      type: Number,
      required: false,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
});
